export default function ({ store }) {
  const gtmIntegration = store.getters["general/getGtmIntegration"];

  if (!gtmIntegration?.gtm_id) {
    return;
  }

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== "dataLayer" ? "&l=" + l : "";

    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    j.onload = () => {
      store.commit("general/SET_INTEGRATION_CALLBACK_STATUS", {
        integrationName: "TYPE_GOOGLE_ANALYTICS",
        status: true,
      });
    };
    j.onerror = () => {
      console.log("GTM script error");
    };
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", gtmIntegration.gtm_id);
}
